import { ICellRendererParams } from 'ag-grid-community';
import './userEmailCellRenderer.scss';
import ListUserEmailDropdown from '../../../../../containers/manageUsers/listUsers/listUserEmailDropdown/listUserEmailDropdown';
import { AppIcon, AppTooltip } from '../../../../../theme';
import { checkIfToolTipRequired } from '../../../../../utils/manageUserHelpers';
import { APP_STATE } from '../../../../../store/reducers';
import { useSelector } from 'react-redux';
import { info } from '../../../../../theme/icons';
import t from '../../../../../localization/en/translation.json';

export const UserEmailCellRenderer = (props: ICellRendererParams) => {
  const { data } = props;
  const user = data?.userDetails;
  const cellStartedEdit = (props as any).cellStartedEdit ?? false;
  const { updateManageUsersResponse: updateResponse } = useSelector(
    (state: APP_STATE) => state.projects
  );

  const isEmailChip = (userType: string) => {
    if (updateResponse?.failedUsers?.length > 0) {
      return updateResponse?.failedUsers?.some(
        (v) => v.email?.toLowerCase() === user?.mail?.toLowerCase()
      );
    }
    return userType === 'External';
  };

  return (
    (user && (
      <>
        {cellStartedEdit || user?.mail?.length === 0 ? (
          <ListUserEmailDropdown props={props} />
        ) : (
          <div className="user-details">
            <div
              className="ellipsis user-email"
              style={{
                width: `${isEmailChip(user.userType) ? '70%' : '100%'}`,
              }}
            >
              {checkIfToolTipRequired(
                user?.mail,
                user.userType === 'External' ? 280 : 305
              ) ? (
                <AppTooltip
                  placement={'top'}
                  className="ellipsis"
                  title={user?.mail}
                >
                  {user?.mail}
                </AppTooltip>
              ) : (
                <>{user?.mail}</>
              )}
            </div>
            {
              <div className="user-status-wrap">
                {updateResponse?.failedUsers?.length > 0 &&
                updateResponse?.failedUsers?.some(
                  (v) => v.email?.toLowerCase() === user?.mail?.toLowerCase()
                ) ? (
                  <>
                    <span className="status-pill failed">
                      {t.manage_user_fail}
                    </span>
                    <AppTooltip
                      title={
                        updateResponse?.failedUsers?.find(
                          (v) =>
                            v.email?.toLowerCase() === user?.mail?.toLowerCase()
                        )?.message ?? t.manage_user_fail_message
                      }
                      placement="top"
                    >
                      <AppIcon icon={info} style={{ fontSize: 14 }} />
                    </AppTooltip>
                  </>
                ) : (
                  <>
                    {(!user?.userType || user.userType === 'External') && (
                      <span className="status-pill">External</span>
                    )}
                  </>
                )}
              </div>
            }
          </div>
        )}
      </>
    )) ||
    null
  );
};
